import React from "react";
import contratSchemaExterne from "../../../doc/schemas/contrat/contrat_externe.json";
import contratSchemaInterne from "../../../doc/schemas/contrat/contrat_interne.json";
import SchemasInterpretor from "./SchemasInterpretor";

const DocContrat = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Documentation Contrat</h1>
          <SchemasInterpretor
            leftSchema={contratSchemaExterne}
            rightSchema={contratSchemaInterne}
            leftTitle="Schéma Contrat Externe"
            rightTitle="Schéma Contrat Interne"
          />
        </div>
      </div>
    </div>
  );
};

export default DocContrat;
